import { render, staticRenderFns } from "./fcertificate.vue?vue&type=template&id=b850d23a&scoped=true&"
import script from "./fcertificate.vue?vue&type=script&lang=js&"
export * from "./fcertificate.vue?vue&type=script&lang=js&"
import style0 from "./fcertificate.vue?vue&type=style&index=0&id=b850d23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850d23a",
  null
  
)

export default component.exports